import Vue from 'vue'
/**权限指令**/
const has = Vue.directive('has', {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function (el, binding, vnode) {
        let requiredPermission = '';
        
        // 支持两种权限配置方式
        if (binding.value) {
            // 直接在指令中指定权限ID: v-has="112"
            requiredPermission = binding.value;
        } else {
            // 从路由配置中获取权限: v-has
            requiredPermission = vnode.context.$route.meta.btnPermission;
        }
        
        if (!Vue.prototype.$_has(requiredPermission)) {
            console.log("not have this permission: " + requiredPermission);
            el.remove()
        }
    }
});

// 权限检查方法
Vue.prototype.$_has = function (requiredPermission) {
    // 如果是管理员，拥有所有权限
    let btnPermission = sessionStorage.getItem("btnPermission");
    
    if (btnPermission === "admin") {
        return true;
    }
    
    // 检查具体权限ID
    if (typeof requiredPermission === 'number' || !isNaN(requiredPermission)) {
        let userPermissions = sessionStorage.getItem("userPermissions");
        
        if (userPermissions) {
            try {
                let permissions = JSON.parse(userPermissions);
                return permissions.includes(parseInt(requiredPermission));
            } catch (e) {
                console.error("解析用户权限失败:", e);
                return false;
            }
        }
        return false;
    }
    
    // 兼容原有的字符串权限检查
    if (btnPermission == undefined || btnPermission == null) {
        return false;
    }
    
    let res = requiredPermission == btnPermission
    if(res) return true
    return false
};

export {has}